import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { ActivatedRoute } from '@angular/router';
import { EntryClassesService } from '../services/entry-classes.service';

interface Entry {
  entry: number,
  horseName: string,
  idPropietario: number,
  id_binomio: number,
  id_caballo: number,
  id_entrenador: number,
  id_jinete: number,
  owner: string,
  riderName: string,
  show: string,
  trainerName: string
}

@Component({
  selector: 'app-entry',
  templateUrl: './entry.component.html',
  styleUrls: ['./entry.component.scss']
})
export class EntryComponent implements OnInit {
  public showId: string;
  public entry: string;
  public entryInfo: Entry = {
    entry: 0,
    horseName: '',
    idPropietario: 0,
    id_binomio: 0,
    id_caballo: 0,
    id_entrenador: 0,
    id_jinete: 0,
    owner: '',
    riderName: '',
    show: '',
    trainerName: ''
  };
  public classes: Array<any> = [];
  public rider: string;
  public isUS: boolean;
  
  // Sorting properties
  public sortColumn: string = '';
  public sortDirection: 'asc' | 'desc' = 'asc';
  
  constructor(private db: AngularFirestore, private route: ActivatedRoute, private entryClassesService: EntryClassesService,) {
    this.showId = this.route.snapshot.paramMap.get('showId');
    this.entry = this.route.snapshot.paramMap.get('entryId');
  }

  ngOnInit(): void {
    this.isUS = this.showId.includes('us_');
    if(this.showId) {
      this.getEntryInfo();
    }
  }

  private getEntryInfo() {
    // Convertir entry a número para la consulta
    const entryNumber = parseInt(this.entry);
    this.db.collection('masterLists', ref => ref.where('show','==',this.showId).where('entry','==',entryNumber))
      .valueChanges().subscribe(
        entries => {
          if (entries && entries.length > 0) {
            this.entryInfo = entries[0] as Entry;
            console.log('masterList',this.entryInfo)
            // Una vez que tenemos la info del entry, ejecutamos getEntryClasses
            this.getEntryClasses();
          } else {
            console.log('No entries found for showId:', this.showId, 'entry:', entryNumber);
          }
        }
      );
  }

  private getEntryClasses() {
    console.log('Getting Classes');
    this.entryClassesService.getEntryClasses(this.entry, this.showId).subscribe(
      response => {
        this.classes = response.classes;
        console.log('Response Classes: ', this.classes);
      }
    );
  }

  // Sorting methods
  public sort(column: string): void {
    if (this.sortColumn === column) {
      // If clicking the same column, toggle direction
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // If clicking a new column, set it as the sort column and default to ascending
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
  }

  public getSortIcon(column: string): string {
    if (this.sortColumn !== column) {
      return '↕️'; // Default icon
    }
    return this.sortDirection === 'asc' ? '↑' : '↓';
  }

  public getSortedClasses(): Array<any> {
    if (!this.sortColumn) {
      return this.classes;
    }

    return [...this.classes].sort((a, b) => {
      let aValue = this.getColumnValue(a, this.sortColumn);
      let bValue = this.getColumnValue(b, this.sortColumn);

      // Handle null/undefined values
      if (aValue === null || aValue === undefined) aValue = '';
      if (bValue === null || bValue === undefined) bValue = '';

      // Convert to strings for comparison
      aValue = String(aValue).toLowerCase();
      bValue = String(bValue).toLowerCase();

      if (this.sortDirection === 'asc') {
        return aValue.localeCompare(bValue);
      } else {
        return bValue.localeCompare(aValue);
      }
    });
  }

  private getColumnValue(item: any, column: string): any {
    switch (column) {
      case 'class':
        return `${item.ClassNumber || ''} ${item.ClassName || ''}`;
      case 'rider':
        return item.Rider || '';
      case 'rank':
        return item.Rank || '';
      case 'ring':
        return item.Ring || '';
      case 'day':
        return item.Date || '';
      case 'start':
        return item.Date || '';
      default:
        return '';
    }
  }
}
